import React from 'react';
import { getCurrentCapacity } from './paintCapacityTools';

const PaintCapacityWidget = (props) => {

  const getTotalByType = (type) => {
    return props.paintOrders.reduce((total, order) => {
      if (order.paintType === type) {
        return total + order.liters;
      }
      return total;
    }
    , 0);
  };

  const getCurrentCapacityRow = (type) => {
    const today = new Date().toISOString().split('T')[0];
    let capacity = type.capacity;
    if (today === props.selectedDate) {
      capacity = getCurrentCapacity(type.capacity, getTotalByType(type.name), type.decrementPerHour)
    } else {
       capacity = type.capacity - getTotalByType(type.name);
    }
    return capacity;
  }

  return (
    props.showData && (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <h4>Capacidad Laboratorio a las: { new Date().toLocaleTimeString() }</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Tipo de Pintura</th>
                  <th>Capacidad Total</th>
                  <th>Planificados</th>
                  <th>Disponibles</th>
                </tr>
              </thead>
              <tbody>
                {props.types.map((type, index) => (
                  <tr key={index}>
                    <td>{type.name}</td>
                    <td>{type.capacity}</td>
                    <td>{getTotalByType(type.name)}</td>
                    <td>{getCurrentCapacityRow(type)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  );
};

export default PaintCapacityWidget;
